import * as Hooks from 'preact/hooks';

/**
 * Track something which can be opened and closed
 */
export const useOpenable = () => {
    const [isOpen, setOpen] = Hooks.useState<boolean>(false);

    return {
        isOpen,
        open: () => setOpen(true),
        close: () => setOpen(false),
    };
};

export const useOpenableWithData = <T>() => {
    const { isOpen, open, close } = useOpenable();
    const [data, setData] = Hooks.useState<T | undefined>();

    return {
        isOpen,
        data,
        open: (d: T) => {
            open();
            setData(d);
        },
        close: () => {
            close();
            setData(undefined);
        },
    };
};

export const useOpenableWithMessage = () => {
    const { isOpen, open, close, data } = useOpenableWithData<string>();

    return {
        isOpen,
        message: data || '',
        open: (message: string) => {
            open(message);
        },
        close: () => {
            close();
        },
    };
};
